import React from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Table } from "antd";
import { Link } from "react-router-dom";
import { ErrorToast, UpdatedToast } from "../../../views/ToastComponent";

const TeaStall = ({ ProfileId, profileId, commingIds }) => {
  console.log("id", commingIds);
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [areaType, setAreaType] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  // const [shopCreated, setShopCreated] = React.useState(false);

  const [garageAutoData, setGarageAutoData] = React.useState({
    name: "",
    businessPdProfileId: commingIds.BusinessPdProfileId,
    latitude: "",
    longitude: "",
    profitMarginId: 0,
    workingDays: 0,
    cupCount: 0,
    cupConsumption: 0,
    sellingPricePerCup: 0,
  });

  const handleClick = async (id) => {
    console.log("id", id);
    try {
      const response = await axios.get(`${Api_Url}api/v1/TeaStall/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("all data", response.data.data);
      setGarageAutoData(response.data.data);
      setIsEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  const handleUpdate = async (id) => {
    console.log("kkk", id);
    try {
      const response = await axios.put(
        `${Api_Url}api/v1/TeaStall/${id}`,
        garageAutoData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("updateed", response.data);
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated");
        setIsEditModalOpen(false);
        fetchIncomeData();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  const columns = [
    {
      title: "Name of Shop",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Working Days",
      dataIndex: "workingDays",
      sorter: (a, b) => a.workingDays.length - b.workingDays.length,
    },
    {
      title: "Number of Cup per Day",
      dataIndex: "cupCount",
      sorter: (a, b) => a.cupCount.length - b.cupCount.length,
    },
    {
      title: "Number of fresh Cup stored",
      dataIndex: "cupConsumption",
      sorter: (a, b) => a.cupConsumption.length - b.cupConsumption.length,
    },
    {
      title: "Selling Price per Cup",
      dataIndex: "sellingPricePerCup",
      sorter: (a, b) =>
        a.sellingPricePerCup.length - b.sellingPricePerCup.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      render: (text) => {
        return (
          new Date(text).toLocaleDateString() +
          "   " +
          new Date(text).toLocaleTimeString()
        );
      },
      sorter: (a, b) => a.created.length - b.created.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Link to={`teastalldetails/${record.id}`}>
          <Button>View Details</Button>
        </Link>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const fetchIncomeData = async () => {
    const { data } = await axios.get(
      Api_Url + "api/v1/TeaStall/getbybusinesspdprofileid/" + profileId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    console.log("Incomde Catering Data", data);
    setAllBusinessPd(data);
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  // Submitting the Data
  const handleSubmit = async () => {
    let response;
    try {
      response = await axios.post(Api_Url + "api/v1/TeaStall", garageAutoData, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      });
      fetchIncomeData();
      setGarageAutoData((prev) => ({
        ...prev,
        name: "",
        businessPdProfileId: profileId,
        profitMarginId: 0,
      }));
      // setShopCreated(true);
      setIsModalOpen(false);
    } catch (error) {
      ErrorToast("Something went wrong");
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchIncomeData();
    fetchAreaType();
    fetchCurentLocation();
  }, []);

  async function handleCancel() {
    setGarageAutoData({
      ...garageAutoData,
      name: "",
      businessPdProfileId: commingIds.BusinessPdProfileId,
      profitMarginId: 0,
      workingDays: 0,
      cupCount: 0,
      cupConsumption: 0,
      sellingPricePerCup: 0,
    });
    // reset form with initial value 0
    setIsModalOpen(false);
    setIsEditModalOpen(false);
  }

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Tea Stall</h3>
          {allBusinessPd.length === 0 && (
            <button
              className="btn btn-primary submit-btn"
              onClick={() => setIsModalOpen(true)}
            >
              Add Tea Stall
            </button>
          )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped bg-white"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Garage Auto Form */}
      <Modal
        title={<h4>Add Tea Stall Shop</h4>}
        open={isModalOpen}
        centered
        onOk={() => setIsModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Shop</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Shop Name"
                    value={garageAutoData.name}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Working Days</label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Working Days"
                    value={garageAutoData.workingDays}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        workingDays: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    No. of fresh cup stored
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Cup sold per day"
                    value={garageAutoData.cupCount}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        cupCount: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Cup Per Day (sold)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Cup Stored"
                    value={garageAutoData.cupConsumption}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        cupConsumption: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Selling Price Per Cup
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Selling Price Per Cup"
                    value={garageAutoData.sellingPricePerCup}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        sellingPricePerCup: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Edit modal */}

      <Modal
        title={<h4>Add Tea Stall Shop</h4>}
        open={isEditModalOpen}
        centered
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleUpdate(garageAutoData.id)}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Shop</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Shop Name"
                    value={garageAutoData.name}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Working Days</label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Working Days"
                    value={garageAutoData.workingDays}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        workingDays: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    No. of fresh cup stored
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Cup sold per day"
                    value={garageAutoData.cupCount}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        cupCount: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Cup Per Day (sold)
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Cup Stored"
                    value={garageAutoData.cupConsumption}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        cupConsumption: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Selling Price Per Cup
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Selling Price Per Cup"
                    value={garageAutoData.sellingPricePerCup}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        sellingPricePerCup: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default TeaStall;
